module.exports = "<strong><l10n>Super Room additional amenities:</l10n></strong><ul><li>Lavazza A Modo Mio capsule coffee machine</li><li>Hansgrohe Raindance 3jet adjustable power shower</li><li>Spacious desk with multiple charging points, desk light and swivel chair</li></ul>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hotels/hotel-room/hotel-room-super-room/hotel-super-room-amenities-tooltip.html
// module id = 3218
// module chunks = 0